import { useEffect, useState } from 'react';

import { mark, measureAndLog } from '@hotjar/performance';
import { MARKS } from '@hotjar/webapp/performance';

// Perf: Mark highlights list render timing

export const useHighlightsListPerformance = (canBeMeasured: boolean): void => {
  const [hasBeenMeasured, setMeasured] = useState(false);

  useEffect(() => {
    mark(MARKS.HIGHLIGHTS_LIST_INITIALIZED);
  }, []);

  useEffect(() => {
    if (canBeMeasured && !hasBeenMeasured) {
      measureAndLog({
        name: MARKS.HIGHLIGHTS_LIST_RENDER_TIME,
        startMark: MARKS.HIGHLIGHTS_LIST_INITIALIZED,
      });
      setMeasured(true);
    }
  }, [canBeMeasured, hasBeenMeasured]);
};
